// extracted by mini-css-extract-plugin
export var animationContainer = "_fz-0";
export var asteriskIcon = "_fz-8";
export var conversationLeftSection = "_fz-4";
export var conversationListItem = "_fz-3";
export var conversationMiddleSection = "_fz-5";
export var conversationRightSection = "_fz-6";
export var detailsContent = "_fz-1";
export var listContainer = "_fz-7";
export var modalContent = "_fz-2";